import { render, staticRenderFns } from "./Tecnicos.vue?vue&type=template&id=3548a60c&"
import script from "./Tecnicos.vue?vue&type=script&lang=js&"
export * from "./Tecnicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports